<template lang="html">
  <div class="trace-container" :style="{'min-height':height+'px'}">
    <div v-if="list.length != 0">
      <p class="setting-p"> 您追踪的信息流列表由你新建的分组生成内容， <router-link :to="{ name: 'AttentionIndex', query: {type: '1',select: 'field'} }">设置关注</router-link> ，追踪更多动态吧~</p>
      <div class="news-item" v-for="(item, index) in list" :key="item.id">
        <a @click="goDetail(item)">【<span v-for="tag in item.type_arr">{{tag | deal('news_topic_type')}}</span><span class="shu">｜</span>{{item.title}}】{{item.content_unsigned}}
          <span v-if="item.src_name" class="comp">({{item.src_name}}等{{item.content_count}}家媒体报道)</span> </a>
        <div class="img-list" v-if="item && item.length!=0">
          <img :preview="item.id" v-for="(img, index) in item.file_arr" :src="$store.state.img_req_url + img.path" :key="img.path">
        </div>
        <div class="last-row">
          <p>{{item.create_time | time_standard}}
            <template v-if="getFirstEntity('0', item.entity) || getFirstEntity('1', item.entity)">
              <span class="shu">|</span> <i class="iconfont">&#xe660;</i>
              <span v-if="getFirstEntity('0', item.entity)" >
                <router-link :to="{ name: 'CompanyDetail', params: { uid: getFirstEntity('0', item.entity).uid} }" target="_blank">{{getFirstEntity('0', item.entity).short_name}}</router-link>
              </span>
              <span v-if="getFirstEntity('1', item.entity)" >
                <router-link :to="{ name: 'OrgDetail', params: { uid: getFirstEntity('1', item.entity).uid} }" target="_blank">{{getFirstEntity('1', item.entity).short_name}}</router-link>
              </span>
            </template>
          </p>
          <div>
            <i class="iconfont s active" title="取消收藏" v-if="item.is_collect" @click="cancelCollect('0', item.id, delCollectCb, index)">&#xe66f;</i>
            <i class="iconfont s" title="收藏" v-else  @click="addCollect('0', item.id, addCollectCb, index)">&#xe66f;</i>
            <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(item.uid)" @on-popper-hide="haddleShareHide">
                <i class="iconfont w">&#xe641;</i>
                <div slot="content" class="share_cnt clear">
                  <div class="share_img"></div>
                  <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                </div>
            </Poptip>
          </div>
        </div>
      </div>
      <div class="more-button" v-if="show_more && !spin_show1" @click="changePage">
        <div>
          加载更多
        </div>
      </div>
      <div class="spin-group" v-if="show_more && spin_show1">
        <Spin fix>
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
      <p class="no-more-p" v-if="!show_more">亲，今日信息已阅读完，明日再来吧。</p>
    </div>
    <defaultPage v-else>
      <p slot="p">抱歉，暂无动态信息，<router-link :to="{ name: 'AttentionIndex', query: {type: '1',select: 'field'} }" >关注更多</router-link> </p>
    </defaultPage>
    <Spin fix v-if="spinShow">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import defaultPage from './default'
import { topicList } from '../../../service'
export default {
  inject: ['addCollect','cancelCollect'],
  data() {
    return {
      height: 0,
      spinShow: true,
      spin_show1: false,
      list: [],
      page: 1,
      show_more: true
    }
  },
  components: {
    defaultPage
  },
  computed: {
    subscribe() {
      return this.$store.state.attention.subscribe.filter((item) => {return item.sub_type == '2'})
    }
  },
  methods: {
    async getTrace() {
      let res = await topicList({
        user_key: this.$store.state.user_key,
        subscribe: '1',
        page: this.page
      }, (error)=>{this.$Message.error('请求错误!')})
      if (res.status == 'success') {
        this.$set(this.$data, 'list', [...this.list, ...res.res])
        if (res.res.length < 10) {
          this.show_more = false
        }
      } else {
        this.$Message.error(res.message)
      }
      this.spinShow = false
      this.spin_show1 = false
    },
    changePage() {
      this.page = this.page + 1
      this.spin_show1 = true
      this.getTrace()
    },
    addCollectCb(index) {
      this.list[index].is_collect = 1
    },
    delCollectCb(index) {
      this.list[index].is_collect = 0
    },
    haddleShare(uid) {
      let share_link = 'https://www.vcbeat.top/News/newsDetail?uid=' + uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
    goDetail(item) {
      // this.$router.push({ name: 'NewsDetail', params:{ uid: item.uid} })
      window.open((process.env.NODE_ENV == 'development' ? 'http://192.168.1.104:8081/newsDetail/': this.$store.state.req_url+'/newsDetail/') + item.uid)
    },
    getFirstEntity(type, entity) { // 查找第一个实体
      let temp = false
      for(let i of entity){
        if (i.type == type) {
          temp = i
          break
        }
      }
      return temp
    }
  },
  created() {
    this.getTrace()
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 155
    // window.onresize =  () => {
    //   this.height = document.documentElement.clientHeight - 195
    // }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/userMain.stylus'
.trace-container
  padding: 30px 20px;
  commonBgColor(#1F2330, #FFFFFF)
  position: relative;
  .setting-p
    font-size:16px;
    font-weight: 500;
    commonColor( #BCBDC1, #333)
    padding-bottom: 28px;
    border-bottom: 1px solid;
    commonBorderColor(#40444F, #f3f3f3)
    a
      color: rgba(250, 122, 80, 1);
      text-decoration: underline;
  .news-item
    padding: 20px 0;
    >a
      font-size:14px;
      font-weight:400;
      commonColor( #BCBDC1, #333)
      line-height:22px;
      display: block;
      text-indent: -6px;
      .comp
        color:#797B83;
      &:hover
        color: rgba(250, 122, 80, 1);
        .comp
          color: rgba(250, 122, 80, 1);
    .img-list
      margin-top: 18px
      font-size: 0
      line-height: 1
      img
        max-width: 160px
        max-height: 80px
        cursor: pointer
      img+img
        margin-left: 20px
    .last-row
      margin-top: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      p
        commonColor(#797B83, #999999)
        font-size: 12px;
        span
          margin-left: 8px;
          // vertical-align: middle;
          &.entity
            margin-left: 14px;
            color: rgba(250, 122, 80, 1);
          &.shu
            commonColor(#797B83, #e9e9e9)
        i
          margin-left: 8px;
          color: rgba(250, 122, 80, 1);
          // vertical-align: text-bottom;
          font-size: 12px;
      div,>>>.ivu-poptip
        i
          width: 18px;
          height: 18px;
          text-align: center;
          line-height: 18px;
          commonColor(#ADAFB4, #cccccc)
          commonBgColor(#343844,#f3f3f3)
          border-radius:2px;
          font-size: 10px;
          display: inline-block;
          cursor: pointer;
          &.s:hover,&.s.active
            color: #fff;
            background:rgba(250, 122, 80, 1);
          &.w:hover,&.w.active
            color: #fff;
            background:#63BF61;
        .ivu-poptip-inner
          border-radius: 0
          .share_cnt
            padding: 10px 20px 10px 10px
            .share_img
              width: 80px
              height: 80px
              float: left
              background: #f0f0f0
            p
              line-height: 20px
              color: #666
              float: right
              margin-top: 20px
              font-size: 14px
        .ivu-poptip-popper
          transform: translate(13px, 0)
      >>>.ivu-poptip
        i
          margin-left: 8px;
  .news-item+.news-item
    border-top: 1px solid;
    commonBorderColor(#40444F, #f3f3f3)
  .spin-group
    position: relative;
    padding: 30px 0;
    border-top: 1px solid;
    commonBorderColor(#40444F, #f3f3f3)
    >>>.ivu-spin-fix
      top: 10px;
</style>
